import { createContext, useContext, useState, ReactNode } from "react";

interface ReportContextValue {
  open: boolean;
  reportId: string | null;
  projectId: string | null;
  openModal: (projectId: string, reportId?: string | null) => void;
  closeModal: () => void;
}

const ReportModalContext = createContext<ReportContextValue | undefined>(undefined);

export const useReportModal = () => {
  const ctx = useContext(ReportModalContext);
  if (!ctx) throw new Error("ReportModalProvider missing");
  return ctx;
};

export function ReportModalProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<{
    open: boolean;
    projectId: string | null;
    reportId: string | null;
  }>({ open: false, projectId: null, reportId: null });

  const openModal = (projectId: string, reportId: string | null = null) =>
    setState({ open: true, projectId, reportId });
  const closeModal = () => setState((s) => ({ ...s, open: false }));

  const value: ReportContextValue = {
    open: state.open,
    projectId: state.projectId,
    reportId: state.reportId,
    openModal,
    closeModal,
  };
  return <ReportModalContext.Provider value={value}>{children}</ReportModalContext.Provider>;
}
